module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-group border-0 timeList latest-notice"
  }, [_vm._l((_vm.notices), function(res, index) {
    return [_c('div', {
      key: index,
      staticClass: "list-start border-0 pr-3 pl-3 pt-0 list-group-item list-group-item-action flex-column align-items-start"
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('div', {
      staticClass: "mb-1 title"
    }, [_vm._v(_vm._s(res.title))])]), _vm._l((res.content), function(eachRes, looping) {
      return _c('li', {
        key: index + '-' + looping,
        staticClass: "border-0 w-100 p-0 pt-2 pb-2 list-group-item justify-content-between",
        attrs: {
          "gtm-on": "click",
          "gtm-event-action": "Menu/Click",
          "gtm-event-label": ("Menu/" + (eachRes.subTitle) + " (" + (res.title) + ")")
        }
      }, [_c('div', {
        staticClass: "timeSlop"
      }, [_vm._v(_vm._s(eachRes.subTitle))]), _c('div', {
        staticClass: "notice-number d-flex align-items-center rounded-circle"
      }, [_c('div', {
        staticClass: "mx-auto text-center"
      }, [_vm._v(_vm._s(eachRes.number))])])])
    })], 2)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36c89a46","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/common/LatestNotice.vue
// module id = 1739
// module chunks = 14